import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './index.css';

// Registrera SW-lyssnare synkront innan React renderas så att meddelanden
// från notisklick (openWindow-fallet) inte tappas pga timing i useEffect.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.data?.type === 'admin_message') {
      window.__pendingAdminMsg = event.data.data.message;
    }
    if (event.data?.data?.type === 'new_wine' && event.data.data.wineId) {
      window.__pendingNewWineId = event.data.data.wineId;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
